<div class="modal" id="header_create_newpopup1" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static" aria-label="Header Popup">
    <div class="modal-content modal-content-40">
      <div class="modal-body">
        <h2 class="modal-heading center mb-20" id="sim_popup_header">
          <span>Please wait for the execution to complete.</span>
        </h2>
        <div id='sim_progress_div' class="sim_prog center bold"></div>
        <div id='what_if_progress_div' class="center"></div>
    </div>
  </div>
</div>
<div class="modal" id="header_create_newpopup2" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static" aria-label="Header Popup">
    <div class="modal-content">
      <div class="modal-body">
        <h2 class="modal-heading center">
          <span>Please wait for the execution to complete.</span>
        </h2>
        <div id='sim_progress_div1' class="center"></div>
    </div>
  </div>
</div>
